import React from 'react';
import { Check } from 'lucide-react';

export function BackgroundPicker({
  backgrounds = [],
  selectedBackgroundId,
  onSelectBackground
}) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
      <div>
        <h4 style={{ fontSize: '13px', fontWeight: 700, color: 'var(--text-main)' }}>
          Background (Hình nền video)
        </h4>
      </div>

      {/* Grid of Mini Background Cards */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(110px, 1fr))', gap: '6px' }}>
        {backgrounds.map((bg) => {
          const isSelected = selectedBackgroundId === bg.id;

          const getBgPreviewStyle = () => {
            const img = bg.imageUrl || bg.previewUrl;
            if (img) {
              return {
                backgroundImage: `url(${img})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                border: '1px solid rgba(0,0,0,0.08)'
              };
            }
            switch (bg.id) {
              case 'bg-paper-ivory':
                return { backgroundColor: '#FAF8F5', border: '1px solid #E2DDD3' };
              case 'bg-minimal-white':
                return { backgroundColor: '#FFFFFF', border: '1px solid #E2E8F0' };
              case 'bg-dark-gradient':
                return { background: 'linear-gradient(180deg, #0F172A 0%, #1E293B 100%)', color: '#FFFFFF' };
              default:
                return { backgroundColor: bg.bgColor || '#FAF8F5' };
            }
          };

          return (
            <div
              key={bg.id}
              onClick={() => onSelectBackground(bg.id)}
              style={{
                borderRadius: 'var(--radius-sm)',
                background: '#FFFFFF',
                border: `1.5px solid ${isSelected ? 'var(--primary)' : 'var(--border-color)'}`,
                cursor: 'pointer',
                overflow: 'hidden',
                display: 'flex',
                flexDirection: 'column',
                transition: 'all var(--transition-fast)'
              }}
            >
              {/* Mini mockup simulation */}
              <div
                style={{
                  height: '52px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: '4px',
                  position: 'relative',
                  ...getBgPreviewStyle()
                }}
              >
                {/* 2 mini boxes A and B with glass blur */}
                <div style={{ display: 'flex', gap: '4px', width: '70%', background: 'rgba(255,255,255,0.75)', padding: '2px', borderRadius: '4px', backdropFilter: 'blur(2px)' }}>
                  <div style={{ flex: 1, height: '10px', borderRadius: '2px', background: '#DC2626', opacity: 0.9 }} />
                  <div style={{ flex: 1, height: '10px', borderRadius: '2px', background: '#2563EB', opacity: 0.9 }} />
                </div>

                {isSelected && (
                  <div
                    style={{
                      position: 'absolute',
                      top: '2px',
                      right: '2px',
                      width: '12px',
                      height: '12px',
                      borderRadius: '50%',
                      background: 'var(--primary)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    <Check size={8} color="#FFFFFF" strokeWidth={3} />
                  </div>
                )}
              </div>

              {/* Title */}
              <div style={{ padding: '4px 6px', textAlign: 'center' }}>
                <span style={{ fontSize: '10px', fontWeight: 700, color: 'var(--text-main)', display: 'block', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  {bg.name}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default BackgroundPicker;
